import { TrackerEvent } from './tracker-event';
import { loadScript } from '@day1co/browser-util';

export class InsiderTracker {
  static create(opts, context) {
    return new InsiderTracker(opts, context);
  }

  constructor({ id, userId }, context) {
    this.id = id;
    this.userId = userId;
    this.name = 'insider';

    loadScript(`//fastcampuscokr.api.useinsider.com/ins.js?id=${this.id}`, { async: 'async' })
      .then(() => {
        window.insider_object = window.insider_object;
      })
      .catch((err) => console.error('insider install err!', err));
  }

  track(event, data) {
    switch (event) {
      case TrackerEvent.PAGE_VIEW: {
        this._track();
        break;
      }
      case TrackerEvent.USER_SIGNUP:
        break;
      case TrackerEvent.USER_LOGIN:
        break;
      case TrackerEvent.FORMAT_VIEW:
        break;
      case TrackerEvent.CATEGORY_VIEW:
        break;
      case TrackerEvent.COURSE_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_PENDING:
        break;
      case TrackerEvent.TRANSACTION_ORDER:
        break;
      case TrackerEvent.TRANSACTION_PAYMENT: {
        this._track();
        break;
      }
      case TrackerEvent.COMMON:
        break;
    }
  }
}
